import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DocumentUtility } from '../../utils';

@Component({
  selector: 'kt-document-card-button',
  templateUrl: './document-card-button.component.html',
  styleUrls: ['./document-card-button.component.scss'],
})
export class DocumentCardButtonComponent {
  @Input() path: string;
  @Input() url: string;
  @Input() blocker: any;
  @Output() opened = new EventEmitter();

  constructor(private documentUtility: DocumentUtility) {}

  getDocumentName(): string {
    return this.documentUtility.getDocumentName(this.path);
  }

  openDocument(): void {
    this.documentUtility.openDocumentDialog({ path: this.path, url: this.url });
    this.opened.emit();
  }

  getBlocker(hover?: boolean): void {
    if (hover) return this.blocker?.description;
    return this.blocker?.code;
  }
}
